import Beta from "../../../../contents/docs/logs/_snippets/beta.mdx";
import * as React from 'react';
export default {
  Beta,
  React
};